import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";
import type { CityStateRequest, CityStateData } from "@/types/account/citystate";
import type { EInvoiceRequest, EInvoiceData } from "@/types/account/einvoice";

import type { ProfileRequest, ProfileData } from "@/types/account/profile";
import type { UpdateProfileRequest, UpdateProfileData } from "@/types/account/updateprofile";
import type { PasswordRequest, PasswordData } from "@/types/account/password";

/* Get Profile */
export async function GetProfile(payload: ProfileRequest) {
  const { data } = await apiClient.post<ApiResponse<ProfileData>>(
    "/api/AgentAccount/getProfile",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Get profile failed");
  }

  return data;
}

/* Update Profile */
export async function UpdateProfile(payload: UpdateProfileRequest) {
  const { data } = await apiClient.post<ApiResponse<UpdateProfileData>>(
    "/api/AgentAccount/updateProfile",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Update profile failed");
  }

  return data;
}

/* Change Password */
export async function ChangePassword(payload: PasswordRequest) {
  const { data } = await apiClient.post<ApiResponse<PasswordData>>(
    "/api/AgentAccount/changePassword",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Change password failed");
  }

  return data;
}

/* Get State and Country by City */
export async function GetStateCountryByCity(payload: CityStateRequest) {
  const { data } = await apiClient.post<ApiResponse<CityStateData>>(
    "/api/AgentAccount/getStateCountryByCity",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Get state and country by city failed");
  }

  return data;
}

/* Update E-Invoice */
export async function UpdateEInvoice(payload: EInvoiceRequest) {
  const { data } = await apiClient.post<ApiResponse<EInvoiceData>>(
    "/api/AgentAccount/updateEInvoice",
    payload,
  );
  
  if (!data.status) {
    throw new Error(data.message ?? "Update e-invoice failed");
  }

  return data;
}